"use client";

import styles from "./styles.module.css";
import H3 from "@components/atoms/H3";
import { useTranslations } from "next-intl";
import React, { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { useIsMobile } from "common/hooks/useIsMobile";

export default function IndustriesTemplate({
  sections,
  translation,
}: {
  sections: any;
  translation: string;
}) {
  const t = useTranslations(translation);

  const [shouldHaveIndex, setShouldHaveIndex] = useState(true);
  const pathname = usePathname();
  const isMobile = useIsMobile();

  useEffect(() => {
    if(translation.includes('eventsAndFestivals') || 
      translation.includes('blockchainSaaS') ||
      translation.includes('artAndCreativity') ||
      translation.includes('finance')
    ) {
      setShouldHaveIndex(false);
    }
  }, [pathname])

  return (
    <section className={styles.container}>
      <ul className={styles.container__ul}>
        {sections.map((item: any, key: number) => {
          return (
            <li key={key}>
              <div className={styles.li__content}>
                <div className={styles.li__wrapper}>
                  <div className={styles.li__title} style={{ textAlign: shouldHaveIndex && isMobile ? "start" : (isMobile ? "center" : "start")}}>
                    {
                      shouldHaveIndex && 
                      <span className="gradient-text-color mr-2 text-[3.5rem] md:text-[5rem]">
                        {key + 1}.
                      </span>
                    }
                    <H3
                      translation={`${translation}.${key}`}
                      text={"title"}
                      style={`gradient-text-color text-[1.7rem] md:text-[3rem] w-full`}
                    />
                  </div>
                  <div className={styles.li__description}>
                    {t(`${key}.description`)}
                  </div>
                </div>
              </div>

              {/* <Image
                  priority={true}
                  width={400}
                  height={200}
                  src={item.img || '/logo-labs-white.webp'}
                  alt='logo'
                  className='object-contain self-center'
                /> */}

              {key !== sections.length - 1 && <FadedLine />}
            </li>
          );
        })}
      </ul>
    </section>
  );
}

function FadedLine({
  color,
  height,
  width,
}: {
  color?: string;
  height?: string;
  width?: string;
}) {
  return (
    <div className={`flex  my-16 h-[2px] w-[100%]`}>
      <div
        className={`flex-1 bg-gradient-to-r from-transparent to-[#4E18A7]`}
      ></div>
      <div className={`h-full w-4 bg-[#4E18A7]`}></div>
      <div
        className={`flex-1 bg-gradient-to-r from-[#4E18A7] to-transparent`}
      ></div>
    </div>
  );
}
